<!-- login.vue -->
<template>
  <div class="enter-login">
    <div class="top"></div>
    <div class="phone-login">
      <div class="text-center animated fadeInDown">
        <div class="login">
          <img src="../../../assets/img/login.png" class="img-responsive" alt="">
        </div>
        <p class="welcome">欢迎登录</p>
        <form action="" role="form" onsubmit="return false">
          <div class="form-group">
            <div class="input-group">
              <input type="text" placeholder="请输入注册手机号" required="required" class="form-control phone numkeyboard" v-model="credentials.name">
            </div>
          </div>
          <div class="form-group">
            <div class="input-group">
              <input type="password" placeholder="请输入账号密码" required="required" class="form-control psw numkeyboard" v-model="credentials.password">
            </div>
          </div>
          <router-link to="/psw_forgot">
            <button type="button" class="btn btn-forget block full-width">忘记密码</button>
          </router-link>
          <button type="submit" class="btn btn-login block full-width" @click="login">登录</button>
        </form>
      </div>
    </div>
  </div>
</template>
<style scoped>

  .btn-forget,.btn-login{
    color: #fff;
    background: #d9534f;
  }
  .btn{
    padding: 6px 0;
  }
  .btn-forget{
    width:24%;
  }
  .btn-login{
    width:100%;
    margin-top:5px;
  }
  .enter-login{
    max-width: 1024px;
    margin: 0 auto;
  }
  .top{
    height:5px;
    background: #f3f3f4;
  }
  .phone-login{
    background: #fff;
    border-top:1px solid #ededed;
    padding: 24px 24px 0;
  }
  .login{
    margin-bottom: 13px;
  }
  .login img{
    width:50%;
    margin: 0 auto;
  }
  input,button{
    outline: none;
  }

  .input-group{
    display: inline;
  }
  .form-control{
    color: #8d8d8d;
    margin-bottom: 14px;
    padding-left: 33px;
    border:1px solid #e5e6e7;
  }
  .phone{
    background: url(../../../assets/img/phone.png) no-repeat 12px center;
    background-size: 15px 15px;
  }
  .psw{
    width:72%;
    background: url(../../../assets/img/pw.png) no-repeat 12px center;
    background-size: 15px 15px;
    margin-right: 4%;
  }
  .btn-forget,.btn-login{
    color: #fff;
    background: #d9534f;
  }
  .btn{
    padding: 6px 0;
  }
  .btn-forget{
    width:24%;
  }
  .btn-login{
    width:100%;
    margin-top:5px;
  }

  .phone{
    background: url(../../../assets/img/phone.png) no-repeat 12px center;
    background-size: 15px 15px;
  }
  .psw{
    background: url(../../../assets/img/pw.png) no-repeat 12px center;
    background-size: 15px 15px;
    width:72%;
    margin-right: 4%;
  }

  .btn-forget,.btn-login{
    color: #fff;
    background: #d9534f;
    width:24%;
  }
  .btn{
    padding: 6px 0;
  }
  .btn-forget{
    width:24%;
  }
  .btn-login{
    width:100%;
    margin-top:5px;
  }

  @media screen and (min-width: 768px) and (max-width: 992px){
    .phone-login{
      padding: 35px 180px 0;
    }
  }
  @media screen and (min-width: 993px) and (max-width: 1024px){
    .phone-login{
      padding: 60px 269px 0;
    }
  }
  @media screen and (min-width: 1025px){
    .phone-login{
      max-width: 650px;
      margin: 0 auto;
    }
  }

</style>
<script>
  //登陆
  import auth from '../../../lib/auth';

  export default {
    data () {
      return {
        credentials: {
          name: '',
          password: ''
        }

      }
    },
    methods: {
      login(){
        auth.login(this,this.credentials).then(() => {
            router.push('registration');
          },error => {
            alert("error")
          }
        )
      }
    }
  }
</script>




// WEBPACK FOOTER //
// login.vue?ba45ac24